import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { ModalController } from '@ionic/angular';
import { PaymentsService } from 'src/app/payments.service';
import { PlatformService } from 'src/app/platform.service';
import { DataService } from 'src/app/services/data.service';
import { ToastService } from 'src/app/services/toast.service';
import { BamboraCheckoutPage } from '../bambora-checkout/bambora-checkout.page';
import { MonerisCheckoutPage } from '../moneris-checkout/moneris-checkout.page';
import { ReceiptPage } from '../receipt/receipt.page';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
@Component({
  selector: 'app-guest-paymentform',
  templateUrl: './guest-paymentform.page.html',
  styleUrls: ['./guest-paymentform.page.scss'],
})
export class GuestPaymentformPage implements OnInit {
  paymentSubmitted = false
  detectTouch = false
  receiptID
  @Input() paymentForm: FormGroup
  @Input() payType: any
  @Input() cartTotal: any
  @Input() item: any
  @Input() fees: any
  width = window.innerWidth;
  processLoading = false;
  submitLoading = false
  constructor(
    private errorHandlerSRV:ErrorHandlerService,
    private toastSRV: ToastService,
    private platformSRV: PlatformService,
    public paymentSRV: PaymentsService,
    public dataService: DataService,
    private iab: InAppBrowser,
    public modalController: ModalController 
  ) {





  }
  closeModal() {
    if (this.detectTouch) {
      this.modalController.dismiss({ receiptID: this.receiptID })
      this.submitLoading = false
    }
    this.modalController.dismiss("keep open")
  }
  ngOnInit() {

  }
  submitPayment() {
    this.processLoading = true;
    var data;
    var items;
    if (this.payType['gateway']?.toString().toLowerCase().includes('hostpay')) {
      data = { PayType: this.payType['PaymentTypeID'] };
      items = {
        ...this.item,
        ...data,
        ...this.paymentForm.value,
        redirect_url: this.dataService.apiUrl + '/www/'

      };
    } else {
      data = { PayType: this.payType['PaymentTypeID'] };
      items = {
        ...this.item,
        ...data,
        ...this.paymentForm.value

      };
    }

    this.dataService.postData('guest/confirm', items).subscribe({
      next: async (res) => {

        if (res['status'] == 'success') {
          this.paymentSubmitted = true
        } else {
          this.processLoading = false;
          this.errorHandlerSRV.displayErrorMessage(res,true)
        }


      },error:err=>{
        this.processLoading = false;
        this.errorHandlerSRV.displayErrorMessage(err,true)
      }
    });
  }

  processPayment() {
    this.submitLoading = true;
    var data;
    var items;
    if (this.payType['gateway'].toString().toLowerCase().includes('hostpay')) {
      data = { PayType: this.payType['PaymentTypeID'] };
      items = {

        ...data,
        ...this.paymentForm.value,
        redirect_url: this.dataService.apiUrl + '/www/'

      };
    } else {
      data = { PayType: this.payType['PaymentTypeID'] };
      items = {

        ...data,
        ...this.paymentForm.value

      };
    }

    this.dataService.postData('guest/process', items).subscribe({
      next: async (res) => {
        //to detect if user manually closed the in app browser
        var closedAutomatically=false
        if (res) {
          if (this.payType['gateway'].toString().toLowerCase().includes('hostpay') && res['packet']) {
            res['packet'] = JSON.parse(res['packet']);
            var url = new URL(res['url'])
            let getPairs = (obj, keys = []) =>
              Object.entries(obj).reduce((pairs, [key, value]) => {
                if (typeof value === 'object')
                  pairs.push(...getPairs(value, [...keys, key]));
                else
                  pairs.push([[...keys, key], value]);
                return pairs;
              }, []);

            let x = getPairs(res['packet'])
              .map(([[key0, ...keysRest], value]) =>
                `${key0}${keysRest.map(a => `[${a}]`).join('')}=${value}`)
              .join('&');
            url.search = x


            const browser = this.iab.create(url.href, '_blank', this.dataService.browserOptionsOptions)
            if (this.platformSRV.isNative.value) {
              var connectedToUrlDetails = new URL(this.dataService.apiUrl)
              browser.on('exit').subscribe(data=>{
                if(closedAutomatically){
                  this.modalController.dismiss({ receiptID: res['packet']['orderID'] })
                } else {
                  this.modalController.dismiss("keep open")
                }
                
              })
              browser.on('loadstart').subscribe(browserResult => {
                var urlDetails = new URL(browserResult.url)
                if (connectedToUrlDetails.hostname == urlDetails.hostname) {
                  closedAutomatically=true
                  browser.close()
                  

                }

              })
            } else {
              this.receiptID = res['packet']['orderID']
              this.detectTouch = true
            }







          } else if (this.payType['gateway'].toString() == 'MonerisCheckout') {
            const desktopModal = await this.modalController.create({
              component: MonerisCheckoutPage,
              breakpoints: [0.5, 0.8, 1],

              cssClass: 'modal-desktop-long',
              componentProps: {
                showReceipt: false,
                res
              }
            });
            const mobileModal = await this.modalController.create({
              component: MonerisCheckoutPage,
              breakpoints: [0.5, 0.8, 1],
              initialBreakpoint: 1,
              cssClass: "modal-mobile-normal",
              componentProps: {
                showReceipt: false,
                res
              }
            })
            const tabletModal = await this.modalController.create({
              component: MonerisCheckoutPage,
              breakpoints: [0.5, 0.8, 1],
              initialBreakpoint: 1,
              cssClass: "modal-tablet-normal",
              componentProps: {
                showReceipt: false,
                res
              }
            })
            var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
            modal.onDidDismiss().then(response => {
              if(response?.data!='keep open'){
                this.modalController.dismiss({ receiptID: res['response']['unique_id'] })
              }

            })
            modal.present()
          } else if (this.payType['gateway'].toString() == 'BamboraCheckout') {
            const desktopModal = await this.modalController.create({
              component: BamboraCheckoutPage,
              breakpoints: [0.5, 0.8, 1],
              initialBreakpoint: 1,
              cssClass: 'modal-desktop-long',
              componentProps: {
                res,
                from: "cart",
                showReceipt: false,

              }
            });
            const mobileModal = await this.modalController.create({
              component: BamboraCheckoutPage,
              breakpoints: [0.5, 0.8, 1],
              initialBreakpoint: 1,
              cssClass: "modal-mobile-normal",
              componentProps: {
                res,
                from: "cart",
                showReceipt: false,

              }
            })
            const tabletModal = await this.modalController.create({
              component: BamboraCheckoutPage,
              breakpoints: [0.5, 0.8, 1],
              initialBreakpoint: 1,
              cssClass: "modal-tablet-normal",
              componentProps: {
                res,
                from: "cart",
                showReceipt: false,

              }
            })
            var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
            modal.onDidDismiss().then(response => {
              if(response?.data!='keep open'){
                this.modalController.dismiss({ receiptID: res['response']['unique_id'] })
              }
             
            })
            modal.present()
            this.submitLoading = false;


          }

          else {
            if (res['confirm_code']) {
              this.submitLoading = false;
              this.modalController.dismiss({ receiptID: res['confirm_code'] })

            }
          }
        } else {
          this.toastSRV.presentErrorToast('an error occured, try again later')
          this.modalController.dismiss("keep open")
        }


      },
      error: async (err) =>{
        this.errorHandlerSRV.displayErrorMessage(err,true)
        this.modalController.dismiss("keep open")
      }
    });
  }


}
